import { Text } from 'ui/baseComponents/Text'
import { colors } from 'theme/colors'

export const MOBILITY_METRICS = {
  doubleSupport: {
    id: 'doubleSupport',
    titleKey: 'report.mobility.metricDoubleSupport',
  },
  stepLength: {
    id: 'stepLength',
    titleKey: 'report.mobility.metricStepLength',
  },
  walkingSpeed: {
    id: 'walkingSpeed',
    titleKey: 'report.mobility.metricWalkingSpeed',
  },
}

export const MOBILITY_EMPTY_STATE_TEXT =
  'No data on step length, walking speed and double support percentage is available for recent period.'

export const APPLE_LINK_USE_THE_HEALTH_APP =
  'https://support.apple.com/en-us/104997'

export const SECTION_MOBILITY_EMPTY_STATE = (
  <Text variant="body16" component="p" data-cy="mobility-section-no-data">
    {MOBILITY_EMPTY_STATE_TEXT}
  </Text>
)

export const FALL_RISK_LEVEL_COLORS = {
  Low: colors.GREEN[500],
  Medium: colors.ORANGE[500],
  High: colors.RED[500],
}
